import React, { useEffect } from "react";
import { Table } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import { getAccountList, doAccountDelete } from "../../../../redux/account/accountState";
import ColumnSearchFilter from 'components/search/ColumnSearchFilter';
import SearchFilter from "components/search/SearchFilter";
import { handleTableChange } from "../../../../utils/index";

const AccountTable = ({ recordList, pagination, doSearch, doDelete, filters }) => {
	const { getColumnSearchProps } = ColumnSearchFilter();
  	const columns = [
		{
	        title: `Code`,
	        dataIndex: 'code',
	        key: 'code',
	        width: '15%',
	        render:(code) => <span>{code}</span>
	    },
		{
	        title: `Name`,
	        dataIndex: 'name',
	        key: 'name',
	        width: '30%',
	        sorter: true,
	        ...getColumnSearchProps('name'),
	        render:(name) => <span>{name}</span>
	    },
		{
	        title: `Profile Summary`,
	        dataIndex: 'description',
	        key: 'description',
	        width: '30%',
	        render:(description) => <span>{description}</span>
	    },
		{
	        title: `Status`,
	        dataIndex: 'status',
	        key: 'status',
	        width: '13%',
	        render:(status) => <span>{status?.name}</span>
	    },
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/accounts/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'id',
	        key: 'id',
	        width: '12%',
	        render:(id) => <CrudOption baseRoute="/console/accounts" recordId={id} deleteHandler={doDelete}/>
	    },
    ];
	
	useEffect(() => {
	    doSearch({paginate: pagination.per_page});
    }, [doSearch, pagination.per_page]);

  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		
	      		<SearchFilter placeholder="Search by Account Name or Code" searchHandler={doSearch} filters={filters} pagination={pagination}/>
	      	
	      		<Table
		        	dataSource={recordList}
		        	columns={columns} 
		            rowKey={(record) => record.id}
		        	pagination={{...pagination, showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}
		            onChange={handleTableChange(doSearch, filters)}  
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.account.recordList?.items,
	pagination: state.account.recordList?.pagination,
	filters: state.account.recordList?.filters,
  	requesting: state.account.recordList?.requesting,
  	error: state.account.recordList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getAccountList(filters)),
  doDelete: (id) => dispatch(doAccountDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountTable);